import { isBoolean, isNil } from '../../../utils/unit';
import { ContextBindingController } from '../ContextBindingController';
/**
 * Binds attributes to a context.
 */
export class ContextAttrsController extends ContextBindingController {
    constructor() {
        super(...arguments);
        this._transformers = new Map();
    }
    /**
     * Binds a context to a attribute on the current `ref` element. By binds we mean as the
     * context value changes it will update the given attribute on the current `ref` element.
     *
     * @param context The context to bind to.
     * @param attrName The name of the attribute to bind the context to.
     * @param transformer An optional transformer to transform the context value before it is
     * stringified and applied as the attribute value. Returning a falsy value such as `null`,
     * `undefined` or `false` will remove the attribtue.
     */
    bind(context, attrName, transformer) {
        const transform = transformer
            ? (_, value) => transformer(value)
            : this._transformAttrValue;
        this._transformers.set(attrName, transform);
        return super.bind(context, attrName);
    }
    _handleBindToContext() {
        // no-op
    }
    _handleBindingUpdate(consumer, attrName) {
        if (this._ref) {
            const name = this._transformAttrName(attrName);
            const transform = this._transformers.get(attrName);
            const value = transform(attrName, consumer.value);
            if (isNil(value) || value === false) {
                this._ref.removeAttribute(name);
            }
            else {
                this._ref.setAttribute(name, `${value}`);
            }
        }
    }
    _handleUnbindFromContext(_, attrName) {
        var _a;
        const name = this._transformAttrName(attrName);
        (_a = this._ref) === null || _a === void 0 ? void 0 : _a.removeAttribute(name);
    }
    /**
     * Override to transform attribute names.
     */
    _transformAttrName(attrName) {
        return attrName;
    }
    /**
     * Override to transform context values. Returning a falsy value such as `null`, `undefined` or
     * `false` will remove the attribtue. This is provided as the default transformer when one
     * isn't provided in the `bind()` method call.
     */
    _transformAttrValue(attrName, value) {
        if (isBoolean(value) && value)
            return '';
        if (typeof value === 'number' && isNaN(value))
            return 0;
        return value;
    }
}
